// Which files and which checklist items count for My Checklist, the Team Checklist and the one-time
// "Start Client Care Checklist" tool (spec 09/27/2026, decision 7). One rule, so the dashboard and the
// tool never disagree about what is live. Pure: no Firebase, no React.
import { toYMD, diffDays, isOpenTask, todayYMD } from "./listingPrep";
import { isActiveUser } from "./roles";
import { isTestFile } from "./testFiles";

// A Closed file keeps its after-closing items (sign down, lockbox pickup) on the list this long.
export const CLOSED_GRACE_DAYS = 30;

const isParkedFileRequest = (d) => d.requestType === "fileRequest" && d.dealStage === "CMAs";

// A live file: not soft-deleted, not archived, not a parked file-request stub, not Cancelled or
// Expired, and Closed only for CLOSED_GRACE_DAYS after its closing date (no readable date: out).
export const inScopeDeal = (deal, today) => {
  if (!deal || typeof deal !== "object") return false;
  if (Number(deal.deletedAt) > 0 || deal.archived === true || isParkedFileRequest(deal)) return false;
  // A test file (utils/testFiles.js) is nobody's work: never on My Checklist or the Team Checklist.
  if (isTestFile(deal)) return false;
  const stage = String(deal.dealStage || "").trim();
  if (!stage || stage === "Cancelled" || stage === "Expired") return false;
  if (stage === "Closed") {
    const closed = toYMD(deal.closingdate);
    if (!closed) return false;
    const since = diffDays(toYMD(today) || todayYMD(), closed);
    return !Number.isNaN(since) && since <= CLOSED_GRACE_DAYS;
  }
  return true;
};

// An item that counts: still open and belonging to the stage the file is in now. Items left open
// from stages the file skipped past (a board drag seeds every stage in between) stay on the deal's
// Task tab but never reach the dashboard. Legacy items with no stage are left out.
export const inScopeTask = (task, deal) =>
  isOpenTask(task) && !!task.stage && String(task.stage).trim() === String((deal && deal.dealStage) || "").trim();

// The item's owner if that person is still on the team, else null (= "no owner"). While the user
// list has not loaded yet, trust the snapshot so nobody's items flash into the no-owner box.
export const activeOwnerOf = (task, users) => {
  const a = task && task.assignee;
  if (!a || !a.id) return null;
  const list = Array.isArray(users) ? users : [];
  if (!list.length) return a;
  const u = list.find((x) => x && String(x.id) === String(a.id));
  return u && isActiveUser(u) ? a : null;
};
